var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 1.33203C4.3266 1.33203 1.33594 4.3227 1.33594 7.9987C1.33594 11.6747 4.3266 14.6654 8.0026 14.6654C11.6786 14.6654 14.6693 11.6747 14.6693 7.9987C14.6693 4.3227 11.6786 1.33203 8.0026 1.33203ZM8.66927 11.332H7.33594V7.33203H8.66927V11.332ZM8.66927 5.9987H7.33594V4.66536H8.66927V5.9987Z",
    fill: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsInfoCircle);
export default __webpack_public_path__ + "static/media/bxs-info-circle.5d66303ecd835d61a59e55e845023557.svg";
export { ForwardRef as ReactComponent };